var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"switches"},_vm._l((_vm.switches),function(item,index){return _c('li',{key:index,staticClass:"switch-item",class:{'active':_vm.currentIndex === index},on:{"click":function($event){_vm.switchItem(index)}}},[_c('span',[_vm._v(_vm._s(item.name)+" ")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-27dc0dee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/base/switches/switches.vue
// module id = null
// module chunks = 